import { useIntl } from 'react-intl'
import Switch from 'LuxKit/Switch/Switch'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { toggleOfferComparisonEnabled } from 'actions/OfferComparisonActions'
import { selectOfferComparisonEnabled } from 'selectors/offerComparisonSelectors'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'
import { trackClientEvent } from 'analytics/analytics'

interface Props {
  className?: string
}

function CompareOffersToggle({ className }: Props) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const enabled = useAppSelector(selectOfferComparisonEnabled)

  const toggleEnabled = () => {
    dispatch(toggleOfferComparisonEnabled())
    trackClientEvent({
      subject: 'search_page_comparison_tool_select',
      action: enabled ? 'toggled_off' : 'toggled_on',
      type: 'interaction',
      category: 'search page',
    })
  }

  return (
    <Group className={className} direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={8}>
      <Group direction="vertical">
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'vdQezJ3_H10ADZDFMc3j',
            defaultMessage: 'Compare offers',
            description: 'Label for offer comparison toggle on the offer listing or detail page',
          })}
        </BodyText>
        <BodyText variant="small" colour="neutral-three">
          {intl.formatMessage(
            {
              id: 'zkd3AROiLVfP5HphQ7_s',
              defaultMessage: 'View up to {max} offers side by side.',
              description: 'Description for offer comparison feature with maximum number of offers',
            },
            { max: MAX_COMPARISON_SELECTIONS },
          )}
        </BodyText>
      </Group>
      <Switch checked={enabled} onClick={toggleEnabled} />
    </Group>
  )
}

export default CompareOffersToggle
